import { useContext } from "react";
import { BaseVideoControls } from "../../../../../../components/app-video/video-models";
import { UGCList } from "../../../../../../models/home-rows";
import { ProductLike } from "../../components/ProductLike/ProductLike.component";
import { ProductShare } from "../../components/ProductShare/ProductShare.component";
import { ProfileDetail } from "../../components/ProfileDetail/ProfileDetail.component";
import { ImageProgressControl } from "../../components/ProgressControl/ImageProgressControl/ImageProgressControl.component";
import { VideoProgressControl } from "../../components/ProgressControl/VideoProgressControl/VideoProgressControl.component";
import { ImagePlayerAction } from "../../modal/funUGCModal.component";
import { FileType } from "../../models/funUgc.model";
import styles from "./UgcPlayerControllerDesktop.module.scss";
import AppContext from "../../../../../../services/app-context-services";

interface UgcPlayerControllerDesktopProps extends BaseVideoControls {
  ugc: UGCList;
  fileType: FileType;
  rowMode: number;
  imageState: ImagePlayerAction;
  setImageState: React.Dispatch<React.SetStateAction<ImagePlayerAction>>;
  onNext: () => void;
}

function UgcPlayerControllerDesktop({
  ugc,
  fileType,
  state,
  rowMode,
  imageState,
  setAction,
  setImageState,
  onNext
}: UgcPlayerControllerDesktopProps) {
  const { isLoggedIn } = useContext(AppContext);

  return (
    <div className={styles.container}>
      <div className={styles.progressbarWrapper}>
        <div className={styles.productLike}>
          {ugc && <ProductShare ugc={ugc} />}
          {ugc && <ProductLike ugc={ugc} rowMode={rowMode} />}
        </div>

        <div className={styles.leftWrapper}>
          <ProfileDetail ugc={ugc} />

          {fileType &&
            (fileType === "Dub" ||
              fileType === "Story" ||
              fileType === "Dubsmash" ||
              fileType === "Gallery") && (
              <VideoProgressControl
                state={state}
                setAction={setAction}
                onNext={onNext}
              />
            )}

          {fileType && (fileType === "Painting" || fileType === "Coloring") && (
            <ImageProgressControl
              imageState={imageState}
              onNext={onNext}
              setImageState={setImageState}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default UgcPlayerControllerDesktop;
